// import Vue from "vue";
const component = Object.create(null);
/* eslint-disable */
import BaseTable from "./BaseTable/index.vue";
import Query from "./BaseForm/query.vue";
import ReadForm from "./BaseForm/descriptions.vue";
import BaseForm from "./BaseForm/index.vue";
import BaseFormItem from "./BaseForm/item.vue";
import Vue from "vue";
component.install = function () {
  Vue.component("BaseTable", BaseTable);
  Vue.component("Query", Query);
  Vue.component("ReadForm", ReadForm);
  Vue.component("BaseForm", BaseForm);
  Vue.component("BaseFormItem", BaseFormItem);
};
export default component;
